module.exports = __webpack_public_path__ + "img/组5387@2x.442d274d.png";